import React, { useEffect, useState } from 'react';
import { YearMonthSelector } from '../../../../../../components/UI-Elements/Date/YearMonthSelector';
import { MonthYear } from '../../../../../../utils/MonthYear/monthYear';
import { CloseButton } from '../../../../../../components/UI-Elements/Buttons/CloseButton';
import ButtonDesigned from '../../../../../../components/UI-Elements/Buttons/ButtonDesigned';

interface Props {
  toggleOverlayOff: () => void;
  setDateOrRange: (dates: MonthYear[] | undefined) => void;
  dateOrRange?: MonthYear[];
}

export const DeliveryDatesOverlay: React.FC<Props> = ({ toggleOverlayOff, setDateOrRange, dateOrRange }) => {
  const [startDate, setStartDate] = useState<MonthYear>();
  const [endDate, setEndDate] = useState<MonthYear>();
  const [toggleFirstOpen, setToggleFirstOpen] = useState(false);

  const resetDates = () => {
    setStartDate(undefined);
    setEndDate(undefined);
    setDateOrRange(undefined);
  };

  useEffect(() => {
    if (toggleFirstOpen) {
      setToggleFirstOpen(false);
    } else {
      setEndDate(undefined);
    }
  }, [startDate]);

  useEffect(() => {
    if (dateOrRange && dateOrRange.length > 0) setStartDate(dateOrRange[0]);
    if (dateOrRange && dateOrRange.length > 1) setEndDate(dateOrRange[1]);
    setToggleFirstOpen(true);
  }, []);

  const submitDatesAndCloseScreen = () => {
    toggleOverlayOff();
    if (startDate) {
      const dates = [startDate];
      endDate && dates.push(endDate);
      setDateOrRange(dates);
    }
  };

  return (
    <div className="fixed inset-0 bg-gray-700 bg-opacity-50 flex items-center justify-center z-50">
      <div className="flex flex-col grow h-full items-center justify-center">
        <div className="flex flex-col gap-5 4 p-4 bg-white shadow-md rounded min-w-[30rem]">
          <div>
            <div className="flex justify-between">
              <div className="text-lg">Select Delivery Time Range</div>
              <CloseButton onClick={toggleOverlayOff}></CloseButton>
            </div>
            <div className="text-sm text-gray-350">Choose order date range for deliveries</div>
          </div>
          <div className="flex divide-x-2 divide-gray-100">
            <div className="pe-[1.875rem]">
              <div className=" flex justify-center mb-[0.75rem]">Start date</div>
              <YearMonthSelector setCurrentMonthYear={setStartDate} currentMonthYear={startDate} monthColNumber={3} />
            </div>
            <div className={`ps-[1.875rem] ${!startDate && 'opacity-30 pointer-events-none'}`}>
              <div className=" flex justify-center mb-[0.75rem]">End date</div>
              <YearMonthSelector
                startingMonth={startDate?.month}
                startingYear={startDate?.year}
                setCurrentMonthYear={setEndDate}
                currentMonthYear={endDate}
                monthColNumber={3}
              />
            </div>
          </div>

          <div className="flex gap-3 justify-end">
            <ButtonDesigned style="outline" onButtonClick={toggleOverlayOff} className="w-24">
              Cancel
            </ButtonDesigned>
            <ButtonDesigned onButtonClick={submitDatesAndCloseScreen} className="w-24 p-2">
              OK
            </ButtonDesigned>
          </div>
        </div>
      </div>
    </div>
  );
};
